import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isUndefined from 'lodash/isUndefined';
import createContentSection from '../../content-section/createContentSection';

const propTypes = {
    params: PropTypes.object.isRequired,
    children: PropTypes.node,
    showAsCollapsed: PropTypes.bool,
    gtmAttribute: PropTypes.string,
};

/**
 * This React component is just a wrapper for the ContentSection javascript
 * component.
 * In the `params` property it can be passed the object that will be passed
 * to the `createContentSection` function.
 *
 * @see shared/components/content-section/createContentSection.js
 */
class ContentSection extends React.Component {
    /**
     * Default constructor.
     *
     * @param {Object} props React's properties.
     */
    constructor(props) {
        super(props);

        this.contentSection = null;
        this.state = {
            headerText: props.params.headerText,
            footerText: props.params.footerText,
            footerLink: props.params.footerLink,
        };
    }

    /**
     * React's lifecycle hook.
     *
     * @return {void}
     */
    componentDidMount() {
        this.contentSection = createContentSection(this.props.params, this.props.gtmAttribute);
        this.contentSection.setContent(this.contentEl);

        if (!isUndefined(this.props.showAsCollapsed) && this.props.showAsCollapsed) {
            this.contentSection.showAsCollapsed();
        }

        this.rootEl.appendChild(this.contentSection.el);
    }

    componentDidUpdate() {
        if (!isEqual(this.state.headerText, this.props.params.headerText)) {
            this.contentSection.setHeaderContent(this.props.params.headerText);

            this.setState({
                headerText: this.props.params.headerText,
            });
        }
    }

    /**
     * React's render method.
     *
     * @return {Object} The react element.
     */
    render() {
        return (
            <div ref={el => { this.rootEl = el; }} >
                <div ref={el => { this.contentEl = el; }} >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

ContentSection.propTypes = propTypes;

export default ContentSection;
